import { Helmet, HelmetData } from "react-helmet-async";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
import { AI_BG_NEW } from "../../../assets";
import {
  CollpaseIconClose,
  CollpaseIconOpen,
} from "../../../icons/collpaseIcon";
import { faqData } from "../../NewHomePage/constants";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
const helmetData = new HelmetData({});

export default function Faqs() {
  const [currentTab, setCurrentTab] = useState("");
  const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {
      if (!searchTerm) {
        setSearchResults([]);
        return;
      }

      const results = faqData.filter(
        (post) =>
          post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          post.body.toLowerCase().includes(searchTerm.toLowerCase())
      );

      setSearchResults(results);
    }, [searchTerm]);


  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>FAQs — [AI] Platform, APUs &amp; Apache Spark | Analytics Intelligence</title>
        <link rel="canonical" href="https://analyticsintelligence.com/faqs" />
        <meta
          name="description"
          content="Common questions about [AI] Platform — how Analytics Processing Units accelerate Apache Spark up to 100× faster, cut analytics costs, support on-premise deployment and data sovereignty, and more."
        />
        <meta
          name="keywords"
          content="[AI] Platform FAQ, Analytics Processing Unit, APU, Apache Spark acceleration, analytics infrastructure, on-premise deployment, data sovereignty, NVIDIA GPU, Analytics Intelligence"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Analytics Intelligence Ltd" />
        <meta property="og:title" content="FAQs — [AI] Platform, APUs & Apache Spark | Analytics Intelligence" />
        <meta property="og:description" content="How [AI] Platform uses Analytics Processing Units to accelerate Apache Spark up to 100× faster, lower costs, support on-premise deployment and data sovereignty." />
        <meta property="og:url" content="https://analyticsintelligence.com/faqs" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://analyticsintelligence.com/favicon.png" />
        <meta property="og:site_name" content="Analytics Intelligence" />
        <meta property="og:locale" content="en_GB" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@_AnalyticsIntel" />
        <meta name="twitter:title" content="FAQs — [AI] Platform, APUs & Apache Spark | Analytics Intelligence" />
        <meta name="twitter:description" content="How [AI] Platform uses Analytics Processing Units to accelerate Apache Spark up to 100× faster, lower costs, support on-premise deployment and data sovereignty." />
        <meta name="twitter:image" content="https://analyticsintelligence.com/favicon.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqData.map((faq) => ({
              "@type": "Question",
              name: faq.title,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.body,
              },
            })),
          })}
        </script>
      </Helmet>

      <main>
        <section
          style={{
            backgroundImage: `url("${AI_BG_NEW}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          className="min-h-[80vh] md:min-h-[95vh] flex items-center"
        >
          <div className="container mx-auto w-full h-full pt-[126px] md:pt-[96px] pb-[0px]">
            <div className="flex flex-col items-center gap-4">
              <h2 className="text-[36px] md:text-[48px] text-center md:text-left font-extrabold leading-[1.3] md:leading-[54px] text-white">
                Frequently Asked Questions
              </h2>

              <p className="text-sm md:text-lg text-center font-medium text-[#E3E3E3] leading-5 max-w-full md:max-w-[1200px]">
                Everything you need to know about Analytics Intelligence
              </p>

              <div className="relative w-[380px] px-6 md:px-0">
                <div className="absolute left-[34px] md:left-[20px] top-2/4 -translate-y-2/4 text-[#888]">
                  <SearchOutlined fontSize="medium" className="text-white" />
                </div>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full py-3 pb-2 pl-12 border text-base bg-[#FFFFFF33] border-[#FFFFFF33] outline-none rounded-full text-white placeholder:text-white"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="container bg-[#010127] space-y-6 relative pb-[96px]">
          {/* FAQ Accordion */}
          <div className="faqs flex flex-wrap gap-[24px] w-full md:w-[80%] xl:w-[70%] justify-center mx-auto ">
            {searchResults.length < 1 && faqData.map((d) => (
              <div
                className="expandable w-full h-max rounded-xl border border-[#FFFFFF3B] p-3 lg:px-6 lg:py-3"
                key={d.title}
                onClick={() => {
                  if (currentTab === d.title) {
                    return setCurrentTab("");
                  }
                  setCurrentTab(d.title);
                }}
              >
                <div className="expandable-header">
                  <p className="!text-[16px] md:!text-[18px] font-bold">
                    {d.title}
                  </p>
                  {currentTab === d.title ? (
                    <CollpaseIconOpen />
                  ) : (
                    <CollpaseIconClose />
                  )}
                </div>
                <p
                  className={` ${
                    currentTab === d.title ? "expand" : ""
                  } expandable-body !text-sm md:!text-base text-[#C0C0C0]`}
                >
                  {d.body}
                </p>
              </div>
            ))}
          </div>

          <div className="faqs flex flex-wrap gap-[24px] w-full md:w-[80%] lg:w-[70%] justify-center mx-auto ">
            {searchResults.length > 0 && searchResults.map((d) => (
              <div
                className="expandable w-full h-max rounded-xl border border-[#FFFFFF3B] p-3 lg:px-6 lg:py-3"
                key={d.title}
                onClick={() => {
                  if (currentTab === d.title) {
                    return setCurrentTab("");
                  }
                  setCurrentTab(d.title);
                }}
              >
                <div className="expandable-header">
                  <p className="!text-[16px] md:!text-[18px] font-bold">
                    {d.title}
                  </p>
                  {currentTab === d.title ? (
                    <CollpaseIconOpen />
                  ) : (
                    <CollpaseIconClose />
                  )}
                </div>
                <p
                  className={` ${
                    currentTab === d.title ? "expand" : ""
                  } expandable-body text-sm md:!text-base text-[#C0C0C0]`}
                >
                  {d.body}
                </p>
              </div>
            ))}
          </div>

          {/* Call to Action */}
         {!searchResults.length > 0 && (
           <div className="text-center">
            <div className="inline-flex items-center text-sm gap-4 bg-[#FFFFFF33] backdrop-blur-sm rounded-full p-3 md:px-6 md:py-3 border border-[#FFFFFF33]">
              <span className="text-blue-200">Can't find your answer?</span>
              <button className="btn-sweep btn-sweep-blue text-white px-6 py-2 rounded-full font-medium" onClick={() => navigate("/contact")}>
                Contact Us
              </button>
            </div>
          </div>
         )}
        </section>
      </main>
    </>
  );
}
